// utils/logActivity.js
import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

// Cache IP to avoid repeated calls
let cachedIP = null;

const fetchJsonWithTimeout = async (url, timeoutMs = 5000) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const res = await fetch(url, {
      method: "GET",
      mode: "cors",
      credentials: "omit", // avoid CORS errors with wildcard ACAO
      signal: controller.signal,
    });
    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }
    return await res.json();
  } finally {
    clearTimeout(timeoutId);
  }
};

const getPublicIP = async () => {
  // if (cachedIP) return { ip: cachedIP, error: null };
  
  // Prioritize IPv4-only JSON services (Axios-friendly)
  const services = [
    'https://api4.ipify.org?format=json', // IPv4-only JSON
    'https://v4.ident.me/.json',          // IPv4-only JSON
    'https://api.ipify.org?format=json'   // Fallback (may return IPv4)
  ];

  let lastError = null;

  for (const url of services) {
    try {
      console.log(`Trying to fetch IP from ${url}...`);
      const data = await fetchJsonWithTimeout(url, 5000);
      const ip = data.ip || data.ip_address; // Handle different response formats
      if (ip) {
        cachedIP = ip;
        console.log("Successfully fetched Public IP:", cachedIP);
        return { ip: cachedIP, error: null };
      }
    } catch (error) {
      console.warn(` Failed to fetch IP from ${url}:`, error.message);
      lastError = error.message;
    }
  }
  
  console.error("All IP fetch attempts failed.");
  return { ip: null, error: lastError || "All services failed" };
};

export const logActivity = async (action, status) => {
  if (!API_URL) {
    return;
  }
  try {
    const uri = typeof window !== "undefined" ? window.location.pathname : action || "/";
    // Try to get public IP, but don't block logging if it fails
    let ip = null;
    let error = null;
    
    try {
      const result = await getPublicIP();
      ip = result.ip;
      error = result.error;
    } catch (ipError) {
      console.warn("IP fetch error:", ipError);
      error = "Unable to fetch public IP";
    }

    await axios.post(`${API_URL}api/log_user_activity/`, {
      action: action || uri,
      status: status || "Success",
      uri,
      ip_address: ip, 
      ip_fetch_error: error // Send error reason to backend
    }, { withCredentials: true });
    // console.log("Activity logged:", response.data.log_id);
  } catch (err) {
    console.error("Activity log failed", err);
  }
};
